import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// Action
export const fetchApprovalGroupsList = createAsyncThunk("fetchApprovalGroupsList", async ({ page, limit, filters }) => {
	const params = new URLSearchParams({
		keyword: filters?.keyword ?? "",
		page: page,
		limit: limit,
		type: filters?.type ?? "",
	});

	try {
		const response = await axiosHttp.get(`groups?${params}`);
		return response.data.data;
	} catch (error) {
		console.error("API Error:", error);
		throw error;
	}
});

const ApprovalGroupsListSlice = createSlice({
	name: "ApprovalGroupsListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchApprovalGroupsList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchApprovalGroupsList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload?.page ?? 1;
			state.total = action.payload?.total ?? 0;
		});

		builder.addCase(fetchApprovalGroupsList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ApprovalGroupsListSlice.reducer;
